module.exports = __webpack_public_path__ + "static/media/edit-profile-off.cef3864d.svg";